<template>
    <v-row justify="center" align="center" class="bod_back_img">
                        
        <v-col class="solid_width" align-self="center" style="max-width: 1440px;">
            <v-overlay :value="overlay">
                <v-progress-circular
                    :size="70"
                    :width="7"
                    color="gray"
                    indeterminate
                    ></v-progress-circular>
            </v-overlay>
            
            <v-card style="margin-top: 30px;width: 100%;" class="rounded-0" :style="{'margin-bottom': category=='gene'?'30px':'0px'}">
                <v-card-title class="blue-grey lighten-5">
                    <!-- {{categoryText}} -->
                    Summary
                </v-card-title>
                
                <v-row justify="center">
                    <v-col align-self="start">

                        <v-simple-table class="pa-2">
                            <template v-slot:default>
                                <tbody v-if="category=='gene'">
                                    <tr class="text-left">
                                        <td style="width: 203px;background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Gene</td>
                                        <td style="width: 1157px;height: 50px; background-color: #F4F9F9 ;" :class="{'red--text':info.error}">
                                            {{ geneName(info) }}
                                        </td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">EntrezId</td>
                                        <td>
                                            <span>{{info.entrez_id}}</span>
                                            <a class="ml-2" :href="info.links" target="_blank" rel="noopener noreferrer">GoTo: {{info.links}}</a>
                                        </td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Accession</td>
                                        <td style="background-color: #F4F9F9 ;">{{info.accession}}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">OtherAliases</td>
                                        <td>
                                            <template v-for="item in get_aliases(info.other_aliases)">
                                                <v-chip label outlined
                                                    class="ma-2"
                                                    :key="item"
                                                    :href="'https://www.ncbi.nlm.nih.gov/gene/?term='+item"
                                                    target="_blank">
                                                    {{item}}
                                                </v-chip>
                                            </template>
                                        </td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Description</td>
                                        <td style="background-color: #F4F9F9 ;">{{info.description}}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Organism</td>
                                        <td>{{info.organism}}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Summary</td>
                                        <td style="background-color: #F4F9F9 ;">{{info.summary}}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Pathways</td>
                                        <td style="background-color: #F7F7F7">
                                            <div style="height: 393px;;" class="overflow-auto">
                                                <p v-for="pathway in pathways" :key="pathway.value" class="ma-0">
                                                    <v-btn text class="text-none" @click="goToPathway(pathway.value)">
                                                        <span style="margin-right: 30px;color: #32A3A2;">{{pathway.value}}</span>
                                                        {{pathway.text}}
                                                    </v-btn>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="category=='mirna'">
                                    <tr class="text-left">
                                        <td style="width: 203px;background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">MiRNA</td>
                                        <td style="width: 1157px;height: 50px; background-color: #F4F9F9 ;" :class="{'red--text':items.length==0}">{{mirnaName(info)}}</td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Accession</td>
                                        <td>
                                            <a></a>
                                            <span>{{info.accession}}</span>
                                        </td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="width: 203px;background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Links</td>
                                        <td style="width: 1157px;height: 50px; background-color: #F4F9F9 ;">
                                            <a>
                                                {{info.links}}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Pathways</td>
                                        <td style="background-color: #F7F7F7">
                                            <div style="height: 393px;;" class="overflow-auto">
                                                <p v-for="pathway in pathways" :key="pathway.value" class="ma-0">
                                                    <v-btn text class="text-none" @click="goToPathway(pathway.value)">
                                                        <span style="margin-right: 30px;color: #32A3A2;">{{pathway.value}}</span>
                                                        {{pathway.text}}
                                                    </v-btn>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else-if="category=='lncrna'">
                                    <tr class="text-left">
                                        <td style="width: 203px;background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">LncRNA</td>
                                        <td style="width: 1157px;height: 50px; background-color: #F4F9F9 ;" :class="{'red--text':items&&items.length==0}">{{lncrnaName(info)}}</td>
                                    </tr>

                                    <template v-if="info.entrez_id!==''">
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">EntrezId</td>
                                            <td>{{info.entrez_id}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Organism</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.organism}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">MapLocation</td>
                                            <td>{{info.map_location}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Description</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.description}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">OtherAliases</td>
                                            <td>{{info.other_aliases}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Summary</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.summary}}</td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Start</td>
                                            <td>{{info.start}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">End</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.end}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Gene ID</td>
                                            <td v-if="info.gene_id !=='' && info.gene_id !== '-' && info.links !== ''"><a :href="info.links">{{info.gene_id}}</a></td>
                                            <td v-else>{{info.gene_id}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Havana Gene</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.havana_gene}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Hgnc ID</td>
                                            <td>{{info.hgnc_id}}</td>
                                        </tr>
                                        <tr class="text-left">
                                            <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Chr</td>
                                            <td style="background-color: #F4F9F9 ;">{{info.chr}}</td>
                                        </tr>


                                    </template>


                                    
                                    <tr class="text-left">
                                        <td style="background-color: #46B2C0;" class="white--text font-weight-bold text-subtitle-1">Pathways</td>
                                        <td style="background-color: #F7F7F7">
                                            <div style="height: 393px;;" class="overflow-auto">
                                                <p v-for="pathway in pathways" :key="pathway.value" class="ma-0">
                                                    <v-btn text class="text-none" @click="goToPathway(pathway.value)">
                                                        <span style="margin-right: 30px;color: #32A3A2;">{{pathway.value}}</span>
                                                        {{pathway.text}}
                                                    </v-btn>
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                    </v-col>
                </v-row>

            </v-card>

            <v-card style="margin-top: 30px;margin-bottom: 30px;width: 100%;" class="rounded-0" v-if="category != 'gene'">
                <v-card-title style="justify-content: center;background-color: #F4F5F7;">
                    <div>
                        <!-- <p style="font-size: 16px;margin-bottom: 0px;">{{pathwayText}}</p> -->
                        <p style="font-size: 16px;margin-bottom: 0px;">Summary</p>
                        <img :src="detail_divider_icon" width="378px" height="26px">
                    </div>
                </v-card-title>

                <div style="width: 1400px;height: 631px;padding: 50px 100px;">
                    <v-simple-table fixed-header height="510px">
                        <template v-slot:default  v-if="category=='mirna'">
                            <thead>
                                <tr style="width: 1200px;height: 68px;">
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">No.</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">miRNA</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Target Gene</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Target Gene (Entrez ID)</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Species</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">References (PMID)</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Support Type</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Experiments</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Datasource</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in items" :key="item.ID" :style="tr_background(index)">
                                  <td>{{index+1}}</td>
                                  <td class="text-center black--text"><a class="black--text" @click="goToSearch(item.miRNA, 'mirna')">{{item.miRNA}}</a></td>
                                  <td class="text-center black--text"><a class="black--text" @click="goToSearch(item.TargetGene, 'gene')">{{item.TargetGene}}</a></td>
                                  <td class="text-center">{{item.TargetGeneEntrez}}</td>
                                  <td class="text-center">Homo sapiens</td>
                                  <td class="text-center black--text">
                                    <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/?term='+item.References" target="_blank" rel="noopener noreferrer" class="black--text text-decoration-none">
                                      {{item.References}}
                                    </a>
                                  </td>
                                  <td class="text-center black--text">{{item.Support ? "Weak" : "Strong"}}</td>
                                  <td class="text-center">{{item.Experiments}}</td>
                                  <td class="text-center">miRTarBase</td>
                                </tr>                                
                            </tbody>
                        </template>
                        <template v-slot:default  v-else-if="category=='lncrna'">
                            <thead>
                                <tr style="width: 1200px;height: 68px;">
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">No.</th>
                                  <th style="width: 190px;font-size: 18px;background-color: #46B2C0;" class="text-center white--text">LncRNA</th>
                                  <th style="width: 170px;font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Target Gene</th>
                                  <th style="width: 170px;font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Target Gene (Entrez ID)</th>
                                  <th style="width: 190px;font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Species</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">References</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Support Type</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Supporting evidence</th>
                                  <th style="font-size: 18px;background-color: #46B2C0;" class="text-center white--text">Datasource</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in items" :key="item.ID" :style="tr_background(index)">
                                  <td>{{index+1}}</td>
                                  <td class="text-center black--text"><a class="black--text" @click="goToSearch(item.LncRNA, 'lncrna')">{{item.LncRNA}}</a></td>
                                  <td class="text-center black--text"><a class="black--text" @click="goToSearch(item.TargetGene, 'gene')">{{item.TargetGene}}</a></td>
                                  <td class="text-center">{{item.TargetGeneEntrez}}</td>
                                  <td class="text-center">Homo sapiens</td>
                                  <td class="text-center black--text">
                                    <!-- <a :href="'https://www.ncbi.nlm.nih.gov/pubmed/?term='+item.References" target="_blank" rel="noopener noreferrer" class="black--text text-decoration-none"> -->
                                    <a :href="item.links" target="_blank" rel="noopener noreferrer" class="black--text text-decoration-none" v-if="item.links !=='' && item.links !== '-'">
                                      {{item.References}}
                                    </a>
                                    <span v-else>-</span>
                                  </td>

                                  <td class="text-center black--text">{{strongWeak(item)}}</td>
                                  <td class="text-center text-uppercase">{{experiment(item)}}</td>
                                  <td class="text-center">{{item.DataSource}}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-btn icon @click="download(category, items)">
                        <v-icon>mdi-tray-arrow-down</v-icon>
                    </v-btn>
                </div>

            </v-card>

        </v-col>
    </v-row>
</template>

<script>
import XLSX from 'xlsx';
export default {
    name: "SearchDetailPage",
    data: () => ({
        detail_divider_icon: "static/img_browse//detail_divider_icon.png",
        overlay: false,

        pathway: null,
        pathwayText: null,
        category: null,
        categoryText: null,
        gene: null,
        strong: null,

        search_gene_img: "static/img_enrichment/enrichment_gene.png",
        search_background: {
            "backgroundImage": "url('static/img_enrichment/enrichment_bakcground.png')",
            "background-repeat":"no-repeat",
            "height": "238px",
            "text-align": "center"
        },
        info: {},
        items: [],
        pathways: [],
    }),
    methods: {
        get_datasets: function(){
            this.overlay = true;
            let successCb = res => {
                let data = res.data;
                this.info = data.info;
                this.items = data.items;
                this.pathways = data.pathways;
            }
            this.axios.get(
                "/searchDetail",
                {
                    params: {
                        "gene": this.gene,
                        "category": this.category,
                        "pathway": this.pathway,
                        "strong": this.strong
                    }
                }
            ).then( res => successCb(res))
            .finally( () => {this.overlay = false})
        },
        create_data: function(){
            this.get_datasets();
        },
        tr_background: function(index){
            if(index%2==0){
                return {"background-color": "#F4F8F9"}
            }
        },
        get_aliases: function(vals){
            if(!vals) return []
            let aliases = vals.split(",").map(val=>val.replace(/\s*/g,""));
            return aliases
        },
        goToPathway: function(pathway){
            let url = this.$router.resolve({
                name: "Browse",
                query: {
                    pathway: pathway,
                }
            })
            window.open(url.href, "_blank")
        },
        goToSearch: function(name, category){
            let categories = {
                gene: "Gene name",
                mirna: "MiRNA name",
                lncrna: "LncRNA name",
            }
            let url = this.$router.resolve({
                name: "SearchDetail",
                query: {
                    category: category,
                    categoryText: categories[category],
                    search: name
                }
            })
            window.open(url.href, "_blank")
        },
        strongWeak: function(item){
            if(item.Support) return "Weak"
            return "Strong"
        },
        experiment: function(item){
            if(item.Support) return item.Weak
            return item.Strong
        },
        geneName: function(info){
            if(info.error){
                return "Query input error"
            }
            return info.gene
        },
        mirnaName: function(info){
            if(this.items.length==0) return "Query input error"
            return info.mirna
        },
        lncrnaName: function(info){
            if(info.error){
                if(this.items.length > 0) return "信息待补全"
                else if(this.items.length == 0) return "Query input error"
            }
            return info.lncrna
        },
        download: function(name, dataset) {
            if(dataset.length == 0) return
            dataset = JSON.parse(JSON.stringify(dataset))
            if(name=='mirnas'){
                dataset.forEach(obj => {
                    obj.Species = 'Homo sapiens';
                    obj.Support = obj.Support ? "Weak" : "Strong";
                    obj.Datasource = "miRTarBase"
                })
            }else if(name=='lncrnas'){
                dataset.forEach(obj => {
                    obj['Species'] = 'sapiens'
                    obj['Support Type'] = this.strongWeak(obj)
                    obj['Supporting evidence'] = this.experiment(obj)
                })
            }
            const data = XLSX.utils.json_to_sheet(dataset)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, data, 'kalacloud-data')
            XLSX.writeFile(wb, `${name}.xlsx`)
        }
    },
    mounted: function(){
        this.pathway = this.$route.query.pathway;
        this.pathwayText = this.$route.query.pathwayText;

        this.category = this.$route.query.category;
        this.categoryText = this.$route.query.categoryText;

        this.strong = this.$route.query.strong;
        this.gene = this.$route.query.search;
        this.create_data();
    }
}
</script>
